module.exports = __webpack_public_path__ + "img/c_4.124a929f.png";